import api from "../../../config/axios-interceptor"

export async function updateAdminProfile(payload) {
    return api.put("/api/v1/admin/update", payload);
}

export async function updateOperatorProfile(payload) {
    return api.put("/api/v1/operator/update", payload);
}

export async function changePassword({oldPassword, newPassword}) {
    return api.put(
        "/api/v1/system-user/update-password",
        {oldPassword: oldPassword, newPassword: newPassword}
    );
}
